// Preview path on the main domain: /rankings/wp-bowls
const ORG_PATH = /^\/rankings\/([a-z0-9][a-z0-9-]*)\/?$/i;

export function slugFromPath(pathname = window.location.pathname) {
  const match = ORG_PATH.exec(pathname || "");
  return match ? match[1].toLowerCase() : null;
}

/**
 * Should this page load render the public organisation tree instead of the
 * main app?
 *
 * Answered synchronously from the URL, before any provider mounts. The main
 * tree blocks rendering until Kinde has initialised and derives its auth
 * redirect from window.location.origin - on an organisation's custom domain
 * that is a callback URI Kinde does not recognise. A public page must never
 * enter that tree, so the decision cannot wait on a network round-trip.
 *
 * Defaults to the main app whenever REACT_APP_PRIMARY_DOMAIN is unset, so a
 * deployment that has not configured it still works normally.
 */
export function isOrgLocation({
  hostname = window.location.hostname,
  pathname = window.location.pathname,
} = {}) {
  if (slugFromPath(pathname)) return true;

  const primary = (process.env.REACT_APP_PRIMARY_DOMAIN || "")
    .trim()
    .toLowerCase();
  if (!primary) return false;

  const host = String(hostname || "").toLowerCase();
  if (!host) return false;

  // Local development serves the main app unless a /rankings/:slug path is used.
  if (host === "localhost" || host === "127.0.0.1" || host === "[::1]") {
    return false;
  }

  return host !== primary && !host.endsWith(`.${primary}`);
}
